<template>
    <div class="card m-1">
        <!-- <h6 v-if="!fileId">Se requiere subir archivos</h6> -->
        <div class="text-center">
            <label class="h6">{{ typeFile }}</label>
            <!-- <p class="h6">{{id ? id : '1234567890'}}</p> -->
            <div :class="file ? 'h1 card m-2 p-1 center' : fileId ? 'h1 card m-2 p-1 center' : 'empty h1 card m-2 p-1 center'" style="align-items: center;">
                <div v-if="file || fileId && !isDeleted">
                    <b-icon-file-earmark-check variant="success" />
                </div>
                <div v-else>
                    <b-icon-file-break />
                </div>
                <h6 style="font-size: 9px">{{file ? file.name : '...'}}</h6>
            </div>
            <b-button v-show="fileId" :disabled="(fileId ? true : false) && isDeleted || (file ? true : false) || $store.state.owner"  @click="clearFiles" size="sm" variant="outline-danger">{{$t('fileUpload.delete')}}</b-button>
        </div>
        <div class="btns">
            <b-button
                v-show="!fileId && !isMobile() ? true : false"
                :disabled="(fileId ? true : false)"
                @click="takePicture"
                class="input-btn mb-0"
                >{{$t('fileUpload.takePicture')}}
            </b-button>
            <label v-if="!fileId && isMobile() ? true : false" class="input-btn mb-0">
                {{$t('fileUpload.takePicture')}}
                <b-form-file
                    type="file"
                    v-model="file"
                    accept="image/*"
                    capture="camera"
                    plain/>
            </label>
            <label v-show="!fileId" class="input-btn ml-4 mb-0">
                {{$t('fileUpload.openFile')}}
                <b-form-file
                    size="sm"
                    accept="image/jpeg, image/png"
                    ref="file"
                    v-model="file"
                    :disabled="(fileId ? true : false) && !isDeleted"
                    plain>
                </b-form-file>
            </label>
        </div>
        <small v-if="!fileId" class="text-muted d-block text-center mt-1">{{$t('fileUpload.imageOnlyHint')}}</small>
        <small v-if="invalidFileType" class="text-danger d-block text-center mt-1">{{$t('fileUpload.invalidType')}}</small>
        <small v-if="uploadError" class="text-danger d-block text-center mt-1">{{ uploadError }}</small>
        <take-picture @picture="picture" :fileTypeId="fileTypeId"/>
        <loading-overlay :active="isLoading" :is-full-page="true" />
        <alert-countdown ref="alertCountdown"/>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import TakePicture from './TakePicture'
import AlertCountdown from '@/components/bodycard/alerts/AlertCountdown'
import { compressImage } from '@/utils/compressImage'

export default {
    name: 'FileUpload',
    components: {
        TakePicture,
      AlertCountdown,
    },
    props: {
        typeFile: String,
        id: Number,
        hasDocument: Boolean,
        fileId: Object,
        fileTypeId: String,
        uploadError: {
            type: String,
            default: null
        }
    },
    data(){
        return {
            file: null,
            isLoading: false,
            isDeleted: false,
            invalidFileType: false,
        }
    },
    watch: {
        file: async function (val) {
            if (!val) {
                this.isLoading = false
                this.$emit('onChangeFIle', val)
                return
            }
            if (!['image/jpeg', 'image/png', 'image/jpg'].includes(val.type)) {
                this.invalidFileType = true
                this.clearLocalFiles() // resetea el <b-form-file>, dispara este watcher de nuevo con val=null
                return
            }
            this.invalidFileType = false
            this.isLoading = true
            const processed = await compressImage(val)
            // Si mientras se comprimía se eligió otro archivo, se descarta este resultado
            // y el overlay sigue activo hasta que termine el más reciente
            if (this.file !== val) {
                return
            }
            this.isLoading = false
            this.$emit('onChangeFIle', processed)
        },
    },
    validations: {
        file:{
            required
        },
    },
    methods: {
        isMobile(){
            if(navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone|iPad|iPod/i)){
                return true
            }else {
                return false
            }
        },
        clearFiles() {
            var id = this.$store.state.bookData.id

            if(this.fileId && !this.isDeleted){
                this.isLoading = true
                this.$root.authApi.delete(`files?id=${this.fileId.id}`)
                .then(res => {
                    this.isLoading = false
                    if(res.status == 200){
                        this.$refs['file'].reset()
                        this.isDeleted = true
                        this.$root.authApi.get(`guests?id=${id}`).then(res => {
                            res.data.id = id
                            this.$store.state.bookData = res.data
                            this.$emit('fileDeleted')
                        })
                    }
                })
                .catch(err => {
                    console.error(err)
                    this.isLoading = false
                    let button = document.createElement('button')
                    button.type = 'button'
                    button.onclick = this.$refs.alertCountdown.showAlert();
                })
            }
            //this.$refs['file'].reset()
        },
        clearLocalFiles(){
            this.$refs['file'].reset()
        },
        takePicture(){
            this.$bvModal.show(`takePicture-${this.fileTypeId}`)
        },
        picture(img){
            this.file = img
        }
    },
    created(){
    }
}
</script>

<style scoped>
	.input-btn{
		padding: 4px;
        background-color: var(--brand-secondary);
        color: #fff;
        border: 2px solid var(--brand-secondary);
        border-radius: var(--brand-radius-sm);
        position: relative;
        cursor: pointer;
        min-height: 44px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
	}
	.btns{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.card {
		padding: 10px;
	}
    .text-readerPicture {
        position: relative;
        overflow: hidden;
        display: inline-grid;

        /* Fancy button looking */
        border: 2px solid var(--brand-secondary);
        border-radius: var(--brand-radius-sm);
        padding: 4px;
        color: #fff;
        background-color: var(--brand-secondary);
    }
    .text-reader {
        position: relative;
        overflow: hidden;
        display: inline-grid;

        /* Fancy button looking */
        border: 2px solid var(--brand-dark);
        border-radius: var(--brand-radius-sm);
        padding: 8px 12px;
        cursor: pointer;
    }
    .input-btn input {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0;
    }
    .text-readerPicture input {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0;
    }
    .text-reader input:focus {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0;
    }
    .empty {
        border-color:red;
    }
</style>
